import React from "react";
import {
  Dialog,
  Box,
  Typography,
  Stack,
  Divider,
  Button,
  Avatar,
  Chip,
  Card,
  CardContent,
} from "@mui/material";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { formatDate, formatDateTime, moneyINR } from "../../../utils/helpers";
// import { formatDate, formatDateTime, moneyINR } from "../../utils/helpers";

export default function DeviceDetailsDialog({
  open,
  onClose,
  device,
  retailerInfo,
  deviceClaims = [],
  onRaiseClaim,
  onOpenClaim,
}) {

  if (!device) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth>
        <Box p={3}>
          <Typography>No device selected</Typography>
        </Box>
      </Dialog>
    );
  }

  const statusLabel = device.is_approved ? "Warranty Active" : "Inactive";
  const statusColor = device.is_approved ? "success" : "default";

  return (
    <Dialog open={open} onClose={onClose} fullWidth 
    sx={{
    "& .MuiDialog-paper": {
      margin: "8px",                 // 👈 reduce outer margin
      width: "calc(100% - 16px)",    // 👈 prevents overflow
    },
  }}>
      <Box p={3}>
        {/* HEADER */}
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h6" fontWeight={900}>
              Device Details
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {device.product_name} • {device.model}
            </Typography>
          </Box>
          <Button onClick={onClose}>Close</Button>
        </Stack>

        <Divider sx={{ my: 2 }} />

        {/* DEVICE SUMMARY */}
        <Card variant="outlined" sx={{ borderRadius: 2 }}>
          <CardContent>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar sx={{ bgcolor: "#eef2ff" }}>
                <PhoneIphoneIcon color="primary" />
              </Avatar>

              <Box flex={1}>
                <Typography fontWeight={900}>
                  {device.product_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Model: {device.model || "—"}
                </Typography>
              </Box>

              <Chip
                size="small"
                color={statusColor}
                label={statusLabel}
              />
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            {/* STATS */}
            <Stack direction="row" spacing={1}>
              <Card sx={{ flex: 1, borderRadius: 3 }}>
                <CardContent sx={{ py: 1.2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Claim Balance
                  </Typography>
                  <Typography fontWeight={900}>
                    {device.available_claim ?? 0}
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{ flex: 1, borderRadius: 3 }}>
                <CardContent sx={{ py: 1.2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Device Price
                  </Typography>
                  <Typography fontWeight={900}>
                    {moneyINR(device.device_price || 0)}
                  </Typography>
                </CardContent>
              </Card>
            </Stack>

            <Divider sx={{ my: 1.5 }} />

            {/* PURCHASE */}
            <Typography fontWeight={900}>Purchase</Typography>
            <Typography variant="body2" color="text.secondary">
              {retailerInfo?.business_name || "—"} <br/>
              Purchased at:{formatDateTime(device.created_at)} <br/>
              {retailerInfo?.contact_person || "—"} • {retailerInfo?.contact_phone}<br/>
              {retailerInfo?.address_line1 || "—"}, {retailerInfo?.address_line2}, {retailerInfo?.city}, {retailerInfo?.state}, {retailerInfo?.pincode}
            </Typography>

            <Divider sx={{ my: 1.5 }} />

            {/* CLAIM HISTORY */}
            <Typography fontWeight={900}>Claim History</Typography>

            <Stack spacing={1} sx={{ mt: 1 }}>
              {deviceClaims.length ? (
                deviceClaims.map((c) => (
                  <Card
                    key={c.id}
                    variant="outlined"
                    sx={{ borderRadius: 2, cursor: "pointer" }}
                    onClick={() => onOpenClaim?.(c)}
                  >
                    <CardContent sx={{ py: 1.3 }}>
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box>
                          <Typography fontWeight={900}>
                            Claim #{c.id}
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                          >
                            {formatDateTime(c.created_at)}
                          </Typography>
                        </Box>
                        <Chip
                          size="small"
                          label={c.status.replace("_", " ").toUpperCase()}
                        />
                      </Stack>
                    </CardContent>
                  </Card>
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No claims yet.
                </Typography>
              )}
            </Stack>

            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 2, borderRadius: 3 }}
              onClick={() => onRaiseClaim?.(device.id)}
            >
              Raise New Claim
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Dialog>
  );
}

